import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseResponseModel } from '../models/BaseResponseModel';
import { Observable } from 'rxjs';
import { UtilsService } from './utils/utils.service';
import { GenderPreference } from '../models/newModels/GenderPreference';
import { ManageUsersAccountService } from './manage-users-account.service';
import { map } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
/**
 * StaffService manages staff operatios (post,get) in database.
 */

const formUrlEncoded = {
  headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
};

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  private _hideBaseUri = this._utilService.getShiftJavaUri();
  private _isystemBaseUri = this._utilService.getISystemBaseUri();
  private _authUrl = this._utilService.getAuthorizationBaseUri();
  private _backgroundCheckUri = this._utilService.getBackgroundCheckUri();
  private _request = {
    service: this._environment.config.SERVICE
  };
  constructor (
    private _http: HttpClient,
    private _userService: ManageUsersAccountService,
    private _environment: AppConfigService,
    private _utilService: UtilsService
  ) {}

  isClientOnHoldISystem() {
    const requestBody = new URLSearchParams();
    requestBody.set('cid', String(this._userService.currentUserValue?.activeusertype?.clientid));
    requestBody.set('section', 'Balance');
    requestBody.set('uid', String(this._userService.currentUserValue?.userid));
    requestBody.set('hash', '');

    return this._http.post<any>(this._isystemBaseUri + '/pages/partcare.php', String(requestBody), formUrlEncoded);
  }

  getGenderPreferences(): Observable<BaseResponseModel<GenderPreference>> {
    return this._http.post<BaseResponseModel<GenderPreference>>(this._isystemBaseUri + '/client/getClientGenderPreferences.php',
      { cid: this._userService.currentUserValue.activeusertype.clientid });
  }

  getIsystemNurseTypes() {
    const fd = new FormData();
    fd.append('Section', 'Coreid');
    fd.append('cid', String(this._userService.currentUserValue.activeusertype.clientid));
    fd.append('uid', String(this._userService.currentUserValue.userid));
    return this._http.post<BaseResponseModel<any>>(`${this._isystemBaseUri}/shift/create.php`, fd);
  }

  getCoreID() {
    return this.getIsystemNurseTypes().pipe(
      map(response => response.data.coreid)
    );
  }

  makeStaffFavorite(favorite: Boolean, uid: number) {
    return this._http.post<BaseResponseModel<any>>(this._isystemBaseUri + '/provider/enableFavorite.php',
      { cid: this._userService.currentUserValue.activeusertype.clientid, uid: uid, favorite: favorite });
  }

  getProviderBookMeStatus(pid: number): Observable<BaseResponseModel<boolean>> {
    return this._http.get<BaseResponseModel<boolean>>(this._backgroundCheckUri + `/bookme/status/pid/${pid}`);
  }

  getBillRatesForFacility() {
    return this._http.post<any>(this._isystemBaseUri + '/manage/clichrgprof.php', {
      cid: this._userService.currentUserValue?.activeusertype?.clientid,
      Section: 'load',
      uid: String(this._userService.currentUserValue?.userid)
    });
  }
}
